import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import { ProfileService } from './services/profile.service';
import { PartnerStatus } from '../models/partner.model';
import { AuthService } from './auth.service';


@Injectable({ providedIn: 'root' })
export class PartnerAuthGuard implements CanActivate {
  constructor(private profileService: ProfileService, private router:Router, private authService: AuthService) { }

  async canActivate(
  ): Promise<boolean> {
    try {
      if (!this.authService.canRecoverSession()) {
        this.authService.clearToken();
        this.router.navigate(['/login']);
        return false;
      }
      if (!this.profileService.profile) {
        await this.profileService.getProfile();
      }
      if (!this.profileService.isPartner) {
        console.error('PartnerAuthGuard: access denied - user is not partner');
        this.router.navigate(this.profileService.homeRoute());
        return false;
      }
      return true;
    } catch (error) {
      console.error('Failed to load profile in PartnerAuthGuard, logging out', error);
      this.authService.logout();
      return false;
    }
  }

  static isPartnerApproved(profileService: ProfileService): boolean {
    return profileService.profile?.partner?.status == PartnerStatus.APPROVED;
  }

}

